import { CountryCode } from "@secureo/common/typings/CountryCode"

const attributeName = "excludedCountryCodes"

const attributeDoesNotExist = `masterData(current(masterVariant(not(attributes(name=\\"${attributeName}\\")))))`

export const getWhereConditionForExcludedCountryCodesNotIn = (notIn: CountryCode[]) => {
	const keyValue = notIn.map((countryCode) => `\\"${countryCode.toLowerCase()}\\"`).join(", ")

	const notInAttribute = `masterData(current(masterVariant(attributes(name=\\"${attributeName}\\" and value(key not in (${keyValue}))))))`

	return `(${notInAttribute} or ${attributeDoesNotExist})`
}
